import React from "react";
import styled from "styled-components";
import Rule from "../../../Rule";
import Image from "../../../Image";
import Heading from "../../../Heading";
import CaseStudiesCard from "../CaseStudiesCard";
import DesignSystemsBuildVsBuy from "../../../../img/casestudy/design-systems/design-system-build-vs-buy.png";
import DesignSystemsBuildVsBuyKendo from "../../../../img/casestudy/design-systems/design-system-build-vs-buy-kendo.png";
import DesignSystemsBuildVsBuyFeelix from "../../../../img/casestudy/design-systems/design-system-build-vs-buy-feelix.png";
import Gridbox from "../../../Gridbox";
import Box from "../../../Box";
import BlogLayout from "../BlogLayout";

const BuildOrBuyImage = styled(Image)`
  margin-bottom: 0;
  ul {
    text-align: left;
    font-size: var(--font-size-text-small);
    list-style: none;
    padding: var(--spacing-clear);
  }
`;

const ContentBoxColumn = styled.div`
  display: grid;
  gap: 48px;
  && {
    margin-bottom: var(--spacing-large);
  }
  @media (min-width: 1400px) {
    gap: 96px;
    grid-template-columns: 1.5fr 2fr;
  }
`;

const BuildOrBuy = (
  <CaseStudiesCard id="buildvsbuy">
    <Heading
      variant="smaller"
      style={{ marginTop: 0, marginBottom: "var(--spacing-x-tiny)", textTransform: "uppercase" }}
    >
      Case Study
    </Heading>
    <p style={{ marginBottom: 0, fontSize: "var(--font-size-text-medium)" }}>
      Evaluating whether to build or buy a component library for MYOB.
    </p>
    <Rule spacing="medium" inverted mt="var(--spacing-medium)" mb="var(--spacing-large)" />

    <BlogLayout wide>
      <Heading>
        Build{" "}
        <span style={{ fontFamily: "var(--font-family)", fontStyle: "italic", opacity: 0.6, letterSpacing: -1 }}>
          vs
        </span>{" "}
        Buy
      </Heading>
      <ContentBoxColumn>
        <Box mb="clear">
          <p>
            At one point, stakeholders asked whether we should keep investing in our in-house system, born from a labour
            of love, or adopt an off-the-shelf alternative.
          </p>
          <p>
            To explore this, we ran a structured assessment of both options, considering what would best support MYOB’s
            teams and deliver long-term value for customers. After evaluating technical fit, brand alignment,
            scalability, and user experience, we decided to continue investing in the Feelix Design System.
          </p>
          <p>
            Originally launched in 2018, Feelix had become a more mature and reliable solution by 2019. It offered
            stronger brand alignment, a better developer experience, and a more consistent customer experience.
            Continued investment meant MYOB could deliver high-quality experiences faster and with greater confidence.
          </p>
        </Box>
        <Gridbox gridTemplateColumns={{ sm: "1fr 1fr" }} gridGap="larger" mb="clear">
          <Box mb="clear">
            <BuildOrBuyImage
              dark
              src={DesignSystemsBuildVsBuyKendo}
              alt="Kendo overview"
              caption={
                <>
                  <Heading variant="smallest">Kendo overview</Heading>
                  <Rule inverted />
                  <ul>
                    <li>
                      <strong>0%</strong> open-source components
                    </li>
                    <li>
                      <strong>0%</strong> brand alignment
                    </li>
                    <li>
                      <strong>10</strong> React components
                    </li>
                    <li>
                      <strong>31</strong> jQuery components
                    </li>
                    <li>
                      <strong>41</strong> total components
                    </li>
                  </ul>
                </>
              }
            />
          </Box>
          <Box mb="clear">
            <BuildOrBuyImage
              dark
              src={DesignSystemsBuildVsBuyFeelix}
              alt="Feelix overview"
              caption={
                <>
                  <Heading variant="smallest">Feelix overview</Heading>
                  <Rule inverted />
                  <ul>
                    <li>
                      <strong>24%</strong> open-source components
                    </li>
                    <li>
                      <strong>100%</strong> brand alignment
                    </li>
                    <li>
                      <strong>44</strong> React components
                    </li>
                    <li>
                      <strong>0</strong> jQuery components
                    </li>
                    <li>
                      <strong>44</strong> total components
                    </li>
                  </ul>
                </>
              }
            />
          </Box>
        </Gridbox>
      </ContentBoxColumn>
      <BuildOrBuyImage
        dark
        src={DesignSystemsBuildVsBuy}
        alt="Build vs Buy comparison map"
        caption="Build vs Buy comparison map"
      />
    </BlogLayout>
  </CaseStudiesCard>
);

export default BuildOrBuy;
